import { gateway } from './api';
import history from './history';

/**
 * Quando o próximo destino é /home, consulta /classes para redirecionar
 * antecipadamente para /turma se o usuário tiver turmas (evita exibir a home antiga).
 * Mesma regra usada no login (LoginNovo/Login.js).
 */
export async function getHomeRedirectPath() {
  try {
    // Só lê o anti-loop; quem grava é a Home ao redirecionar para /turma.
    if (typeof window !== 'undefined' && window.sessionStorage) {
      const last = parseInt(
        window.sessionStorage.getItem('redirectedToNewHomeAt') || '0',
        10
      );
      if (!Number.isNaN(last) && Date.now() - last < 5000) return '/home';
    }
    const data = await gateway('/webbff/lit_app_web/classes');
    if (Array.isArray(data) && data.length > 0) {
      return '/turma';
    }
  } catch (e) {
    // ignore (ex.: sem permissão, rede) — segue para /home
  }
  return '/home';
}

/**
 * /turma é outro projeto (proxy): precisa full load para o app carregar.
 * /home e demais rotas seguem com history.push no SPA.
 */
export function navigateToHomeOrTurma(path) {
  if (path === '/turma') {
    window.location.assign('/turma');
  } else {
    history.push(path);
  }
}

export async function goToHomeOrTurma() {
  const path = await getHomeRedirectPath();
  navigateToHomeOrTurma(path);
}
